import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import styles from '../../../styles';

const StyledWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  padding: 1rem 1.875rem;
  box-sizing: border-box;

  display: flex;
  justify-content: space-between;

  color: #aaa;
  line-height: 1.35rem;

  a {
    color: ${styles.color.ORANGE};
    font-family: ApercuBold;
  }

  button {
    background-color: ${styles.color.ORANGE};
    border-radius: 0.75rem;
    box-sizing: border-box;
    padding: 0.5rem 1.65rem;
    border: transparent;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
    margin-left: 2rem;
    align-self: center;
    align-items: center;
    display: flex;
    color: white;
    text-transform: uppercase;
    font-family: ApercuBold;
  }
`;

const CookiePolicy = props => {
  const { onGotItClick } = props;
  return (
    <StyledWrapper>
      <div>
        Our site uses cookies to enhance your user experience, tailor ads and
        measure site traffic.<br />
        <NavLink to="/privacy-policy">Learn More.</NavLink>
      </div>
      <button onClick={onGotItClick}>Got it!</button>
    </StyledWrapper>
  );
};

CookiePolicy.propTypes = {
  onGotItClick: PropTypes.func.isRequired,
};

export default CookiePolicy;



// WEBPACK FOOTER //
// ./src/modules/core/components/CookiePolicy.js